function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import moment from "moment-timezone";
import isToday from "date-fns/isToday";
import isYesterday from "date-fns/isYesterday";
import isSameDay from "date-fns/isSameDay";
import { HiDownload, HiPencil } from "react-icons/hi";
import Button from "react-bootstrap/Button";
import { FilterContext, UserContext, SearchContext } from "../index";
import { TIMESHEET_QUERY, USER_TIMESHEET_COUNT_QUERY, TIMESHEET_EXPORT_QUERY } from "./query";
import { useQuery, useLazyQuery } from "@apollo/client";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { arrayToStringOutput, arrayToStringOutputForTimesheet, stringToArrayOutput } from "./../SideMenu/Header";
import "./TimeSheet.css";
import Loader from "./../Loader/Loader";
import Profile from "../img/workfolio-latest.png";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { findIsWorkfolioSite } from "../utils";
import { MultiSelect } from "react-multi-select-component";
import Excel from "exceljs/dist/es5/exceljs.browser";
import { saveAs } from "file-saver";
import Pagination from "react-bootstrap/Pagination";
import { EditUserDetailsModal } from "../EditTimesheet/EditTimesheet";
import { ORGANISATION_TEAMS_QUERY } from "./../SideMenu/query";
import { BillingDueExtendedMsg, BillingBankTrasferPlanEndBeforeMsg } from "./../Billing/Billing";
import { WarningCardOrgTimezone, WarningCardMaintenance } from "./../Dashboard/Dashboard";
var USER_LIMIT = 10;
var weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
var clickedIndex = 0;
var TimeSheet = function TimeSheet(props) {
  var _timesheetData$timesh3, _displayNameWithSearc, _displayNameWithSearc2, _displayNameWithSearc3, _timesheetValue, _displayNameWithSearc4, _displayNameWithSearc5;
  var Link = props.linkComponent,
    linkProps = props.linkProps;
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    ImageViewerNextNavCount = _React$useState2[0],
    setImageViewerNextNavCount = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    ImageViewerPrevNavCount = _React$useState4[0],
    setImageViewerPrevNavCount = _React$useState4[1];
  var _React$useState5 = React.useState(1),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    activeTimeline = _React$useState6[0],
    setActiveTimeline = _React$useState6[1];
  var _React$useState7 = React.useState(null),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    editUserModalShow = _React$useState8[0],
    setEditUserModalShow = _React$useState8[1];

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  var handleEditUserModalClose = function handleEditUserModalClose() {
    setEditUserModalShow(null);
  };
  var handleEditUserModalShow = function handleEditUserModalShow(data) {
    var temp = _objectSpread({}, data);
    setEditUserModalShow(temp);
  };
  var _React$useState9 = React.useState(JSON.parse(localStorage.getItem("timesheetParameter")) || []),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    parameterCheck = _React$useState10[0],
    setParameterCheck = _React$useState10[1];
  var siteName = findIsWorkfolioSite();
  if (!localStorage.getItem("timesheetParameter")) {
    var param = [{
      label: "Clock In",
      value: "IN",
      summary: "clockIn"
    }, {
      label: "Clock Out",
      value: "OUT",
      summary: "clockOut"
    }, {
      label: "Worked Hours",
      value: "WORK",
      summary: "Worked hours"
    }, {
      label: "Active Time",
      value: "ACTIVE",
      summary: "Active time"
    }, {
      label: "Idle Time",
      value: "IDLE",
      summary: "Idle time"
    }];
    localStorage.setItem("timesheetParameter", JSON.stringify(param));
    localStorage.setItem("timesheetIdleParamMigrated", "true");
    setParameterCheck(JSON.parse(localStorage.getItem("timesheetParameter")));
  } else {
    // One-time migration: add the "IDLE" (Idle Time) option for users whose stored
    // parameters predate it. Guarded by a persistent flag so it never re-adds after
    // the user intentionally removes Idle Time from the filter.
    var storedParam = JSON.parse(localStorage.getItem("timesheetParameter")) || [];
    var hasIdle = storedParam.some(function (p) {
      return p.value === "IDLE";
    });
    var idleMigrationDone = localStorage.getItem("timesheetIdleParamMigrated") === "true";
    if (!hasIdle && !idleMigrationDone) {
      var updatedParam = [].concat(_toConsumableArray(storedParam), [{
        label: "Idle Time",
        value: "IDLE",
        summary: "Idle time"
      }]);
      localStorage.setItem("timesheetParameter", JSON.stringify(updatedParam));
      setParameterCheck(updatedParam);
    }
    localStorage.setItem("timesheetIdleParamMigrated", "true");
  }
  var _React$useContext = React.useContext(FilterContext),
    teamId = _React$useContext.teamId,
    organisationId = _React$useContext.organisationId,
    globalStartDate = _React$useContext.startDate,
    globalEndDate = _React$useContext.endDate,
    role = _React$useContext.role,
    organisationBilling = _React$useContext.organisationBilling,
    from = _React$useContext.from,
    organisationSettings = _React$useContext.organisationSettings,
    organisationUserCount = _React$useContext.organisationUserCount,
    organisationStatus = _React$useContext.organisationStatus,
    timezoneFilter = _React$useContext.timezoneFilter;
  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;
  var _React$useContext3 = React.useContext(SearchContext),
    search = _React$useContext3.search;
  var _React$useState11 = React.useState(0),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    loopInit = _React$useState12[0],
    setLoopInit = _React$useState12[1];
  var _React$useState13 = React.useState([]),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    allUsers = _React$useState14[0],
    setAllUsers = _React$useState14[1];
  var _React$useState15 = React.useState(false),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    exportButton = _React$useState16[0],
    setExportButton = _React$useState16[1];
  React.useEffect(function () {
    if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null && role != "Member" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  React.useEffect(function () {
    if (from == "web" && role == "Member" && !(organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.allowMemberToAccessTimesheet)) {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  React.useEffect(function () {
    if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped" && role != "Member" && from === "web") {
      var _param = [{
        label: "Clock In",
        value: "IN",
        summary: "clockIn"
      }, {
        label: "Clock Out",
        value: "OUT",
        summary: "clockOut"
      }
      // { label: "Worked Hours", value: "WORK", summary: "Worked hours" },
      ];
      localStorage.setItem("timesheetParameter", JSON.stringify(_param));
      setParameterCheck(JSON.parse(localStorage.getItem("timesheetParameter")));
    }
  }, [organisationBilling]);
  React.useEffect(function () {
    setActiveTimeline(1);
  }, [search]);
  var startDayUnix = Number(moment(globalStartDate).format("x"));
  var endDayUnix = Number(moment(globalEndDate !== null && globalEndDate !== void 0 ? globalEndDate : globalStartDate).format("x"));
  var endDateForDiff = endDayUnix;
  if (globalEndDate > moment()) {
    endDateForDiff = Number(moment().format("x"));
  }
  var startDay = moment(startDayUnix).startOf("day");
  var endDay = !globalEndDate ? moment(endDateForDiff).endOf("day") : moment(endDateForDiff);
  var filterDaysDiff = Math.ceil(moment.duration(moment(endDay).diff(startDay)).asDays());
  var exportOffsets = 0;
  var exportLimit = filterDaysDiff >= 15 && organisationUserCount >= 100 ? 100 : 0;
  // let exportLimit = 50;

  var loopCount = exportLimit != 0 ? Number(Math.ceil(organisationUserCount / exportLimit)) + 1 : 1;
  var dateFilter = arrayToStringOutput([globalStartDate, globalEndDate], organisationSettings.organisationTimezone);

  // if (dateFilter === "Today" || dateFilter === "Yesterday" || isSameDay(startDayUnix, endDayUnix)) {
  //   daysDiff = 1;
  // }
  // if (dateFilter === "Last 7 Days") {
  //   daysDiff = 7;
  // }

  React.useEffect(function () {
    setLoopInit(0);
    exportOffsets = 0;
    setAllUsers([]);
  }, [globalStartDate]);
  var daysDiff = 0;
  var _useQuery = useQuery(TIMESHEET_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        startDate: startDayUnix,
        endDate: endDayUnix,
        userRole: role,
        limit: USER_LIMIT,
        offset: (Number(activeTimeline) - 1) * Number(USER_LIMIT),
        searchText: search,
        timezoneFilter: timezoneFilter,
        dateRange: dateFilter
      },
      skip: !organisationId || !teamId
    }),
    timesheetData = _useQuery.data,
    timesheetError = _useQuery.error,
    timesheetLoading = _useQuery.loading,
    refetch = _useQuery.refetch;
  var _useQuery2 = useQuery(USER_TIMESHEET_COUNT_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        startDate: startDayUnix,
        endDate: endDayUnix,
        userRole: role,
        searchText: search
      },
      skip: !search.length || !organisationId || !teamId
    }),
    userTimeSheetCountData = _useQuery2.data,
    userTimeSheetCountError = _useQuery2.error,
    userTimeSheetCountLoading = _useQuery2.loading,
    userTimeSheetCountRefetch = _useQuery2.refetch;
  var _useLazyQuery = useLazyQuery(TIMESHEET_EXPORT_QUERY, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
      }
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getExport = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    exportLoading = _useLazyQuery2$.loading,
    exportData = _useLazyQuery2$.data;
  var _useQuery3 = useQuery(ORGANISATION_TEAMS_QUERY, {
      variables: {
        organisationId: organisationId,
        from: "web"
      }
    }),
    teamData = _useQuery3.data,
    teamError = _useQuery3.error,
    teamLoading = _useQuery3.loading;
  React.useEffect(function () {
    refetch === null || refetch === void 0 ? void 0 : refetch();
  }, [props.location.key]);
  var timesheetValueData;
  if ((props === null || props === void 0 ? void 0 : props.from) === "desktop" && (role === "Admin" || role === "Head") || (props === null || props === void 0 ? void 0 : props.from) !== "desktop") {
    var _timesheetData$timesh;
    timesheetValueData = timesheetData === null || timesheetData === void 0 ? void 0 : (_timesheetData$timesh = timesheetData.timesheet) === null || _timesheetData$timesh === void 0 ? void 0 : _timesheetData$timesh.users;
  } else {
    var _timesheetData$timesh2;
    timesheetValueData = timesheetData === null || timesheetData === void 0 ? void 0 : (_timesheetData$timesh2 = timesheetData.timesheet) === null || _timesheetData$timesh2 === void 0 ? void 0 : _timesheetData$timesh2.users.filter(function (object) {
      return object.user.userId === user.userId;
    });
  }
  daysDiff = Number((timesheetData === null || timesheetData === void 0 ? void 0 : (_timesheetData$timesh3 = timesheetData.timesheet) === null || _timesheetData$timesh3 === void 0 ? void 0 : _timesheetData$timesh3.daysDiff) || 0);
  if (isNaN(daysDiff) || daysDiff < 0) {
    daysDiff = 0;
  }
  var timesheetValue = [];
  if (timesheetValueData) {
    var myData = _toConsumableArray(timesheetValueData);
    // myData.sort((a, z) => {
    //   if (a.user.displayName.toLowerCase() < z.user.displayName.toLowerCase()) {
    //     return -1;
    //   }
    //   if (a.user.displayName.toLowerCase() > z.user.displayName.toLowerCase()) {
    //     return 1;
    //   }
    //   return 0;
    // });
    timesheetValue = myData;
  }
  var timesheetValueDataExport;
  if ((props === null || props === void 0 ? void 0 : props.from) === "desktop" && (role === "Admin" || role === "Head") || (props === null || props === void 0 ? void 0 : props.from) !== "desktop") {
    var _exportData$timesheet;
    timesheetValueDataExport = exportData === null || exportData === void 0 ? void 0 : (_exportData$timesheet = exportData.timesheetExport) === null || _exportData$timesheet === void 0 ? void 0 : _exportData$timesheet.users;
  } else {
    var _exportData$timesheet2;
    timesheetValueDataExport = exportData === null || exportData === void 0 ? void 0 : (_exportData$timesheet2 = exportData.timesheetExport) === null || _exportData$timesheet2 === void 0 ? void 0 : _exportData$timesheet2.users.filter(function (object) {
      return object.user.userId === user.userId;
    });
  }
  var timesheetValueExport = [];
  if (timesheetValueDataExport) {
    var _myData = _toConsumableArray(timesheetValueDataExport);
    _myData.sort(function (a, z) {
      if (a.user.displayName.toLowerCase() < z.user.displayName.toLowerCase()) {
        return -1;
      }
      if (a.user.displayName.toLowerCase() > z.user.displayName.toLowerCase()) {
        return 1;
      }
      return 0;
    });
    timesheetValueExport = _myData;
  }
  var times = React.useMemo(function () {
    var timesArray = [];
    var timesheetDataValues = timesheetValue;
    if (!timesheetDataValues) {
      return [];
    }
    for (var index = 0; index < timesheetDataValues.length; index++) {
      var element = timesheetDataValues[index];
      timesArray.push(element.days);
    }
    return timesArray.reduce(function (acc, curr) {
      acc = [].concat(_toConsumableArray(acc), _toConsumableArray(curr));
      return acc;
    }, []);
  }, [timesheetValue]);
  var csvData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(allUsers) {
      var dataValues, myData, wb, ws, headers, buf, fileName;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dataValues = allUsers;
            if (allUsers) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", []);
          case 3:
            myData = _toConsumableArray(allUsers);
            myData.sort(function (a, z) {
              if (a.user.displayName.toLowerCase() < z.user.displayName.toLowerCase()) {
                return -1;
              }
              if (a.user.displayName.toLowerCase() > z.user.displayName.toLowerCase()) {
                return 1;
              }
              return 0;
            });
            dataValues = myData;
            wb = new Excel.Workbook();
            ws = wb.addWorksheet();
            headers = [{
              header: "Date",
              key: "date",
              width: 20,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Display Name",
              key: "displayName",
              width: 10,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "EmailId",
              key: "emailId",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Employee ID",
              key: "employeeId",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Team Name",
              key: "teamName",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }];
            if (parameterCheck.some(function (t) {
              return t.summary === "clockIn";
            })) {
              headers.push({
                header: "clockIn",
                key: "clockIn",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
            }
            if (parameterCheck.some(function (t) {
              return t.summary === "clockOut";
            })) {
              headers.push({
                header: "clockOut",
                key: "clockOut",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
            }
            if (parameterCheck.some(function (t) {
              return t.summary === "Worked hours";
            })) {
              headers.push({
                header: "Total Worked Hours",
                key: "totalWorkedHours",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
              headers.push({
                header: "Total Worked Minutes",
                key: "totalWorkInMins",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
            }
            if (parameterCheck.some(function (t) {
              return t.summary === "Break time";
            })) {
              headers.push({
                header: "Break Hours",
                key: "breakHours",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
              headers.push({
                header: "Break Minutes",
                key: "breakMins",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
            }
            if (parameterCheck.some(function (t) {
              return t.summary === "Idle time";
            })) {
              headers.push({
                header: "Idle Hours",
                key: "idleHours",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
              headers.push({
                header: "Idle Minutes",
                key: "idleInMins",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
            }
            if (parameterCheck.some(function (t) {
              return t.summary === "Active time";
            })) {
              headers.push({
                header: "Active Hours",
                key: "activeHours",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
              headers.push({
                header: "Active Minutes",
                key: "activeMins",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
            }
            if (parameterCheck.some(function (t) {
              return t.summary === "Productive";
            })) {
              headers.push({
                header: "Productive Apps Time",
                key: "productiveAppsTime",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
              headers.push({
                header: "Productive Apps Time In Minutes",
                key: "productiveInMins",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
            }
            if (parameterCheck.some(function (t) {
              return t.summary === "Unproductive";
            })) {
              headers.push({
                header: "Unproductive Apps Time",
                key: "unproductiveAppsTime",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
              headers.push({
                header: "Unproductive Apps Time In Minutes",
                key: "unproductiveInMins",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
            }
            if (parameterCheck.some(function (t) {
              return t.summary === "Neutral";
            })) {
              headers.push({
                header: "Neutral Apps Time",
                key: "neutralAppsTime",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
              headers.push({
                header: "Neutral Apps Time In Minutes",
                key: "neutralInMins",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
            }
            if (parameterCheck.some(function (t) {
              return t.summary === "Untrack";
            })) {
              headers.push({
                header: "Untracked Hours",
                key: "untrackedHours",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
              headers.push({
                header: "Untracked Minutes",
                key: "untrackInMins",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
            }
            if (parameterCheck.some(function (t) {
              return t.summary === "Manual";
            })) {
              headers.push({
                header: "Manual Hours",
                key: "manualHours",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
              headers.push({
                header: "Manual Minutes",
                key: "manualInMins",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
            }
            headers.push({
              header: "Timesheet Mode",
              key: "timesheetMode",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            });
            ws.columns = headers;
            dataValues.map(function (item, index) {
              item.days.map(function (c, i) {
                //timesheet.updatedBy

                var t = {
                  date: c.dateForExport,
                  displayName: c.displayName.toString(),
                  emailId: item.user.emailId,
                  employeeId: item.user.employeeId,
                  teamName: item.user.team
                };
                if (parameterCheck.some(function (t) {
                  return t.summary === "clockIn";
                })) {
                  var clockIn = c["in"] !== undefined && c["in"] !== null ? moment(Number(c["in"])).format("hh:mm a") : Number(c.workInMins) > 0 ? "-" : "00:00";
                  t = _objectSpread(_objectSpread({}, t), {}, {
                    clockIn: clockIn
                  });
                }
                if (parameterCheck.some(function (t) {
                  return t.summary === "clockOut";
                })) {
                  var clockOut = c.out == "Working On" || c.out == "-" ? c.out : c.out !== undefined && c.out !== null ? moment(Number(c.out)).format("hh:mm a") : "00:00";
                  t = _objectSpread(_objectSpread({}, t), {}, {
                    clockOut: clockOut
                  });
                }
                if (parameterCheck.some(function (t) {
                  return t.summary === "Worked hours";
                })) {
                  var totalWorkedHours = c.work;
                  var totalWorkInMins = c.workInMins;
                  t = _objectSpread(_objectSpread({}, t), {}, {
                    totalWorkedHours: totalWorkedHours,
                    totalWorkInMins: totalWorkInMins
                  });
                }
                if (parameterCheck.some(function (t) {
                  return t.summary === "Break time";
                })) {
                  var breakHours = c["break"];
                  var breakInMins = c.breakInMins;
                  t = _objectSpread(_objectSpread({}, t), {}, {
                    breakHours: breakHours,
                    breakInMins: breakInMins
                  });
                }
                if (parameterCheck.some(function (t) {
                  return t.summary === "Idle time";
                })) {
                  var idleHours = c.idle;
                  var idleInMins = c.idleInMins;
                  t = _objectSpread(_objectSpread({}, t), {}, {
                    idleHours: idleHours,
                    idleInMins: idleInMins
                  });
                }
                if (parameterCheck.some(function (t) {
                  return t.summary === "Active time";
                })) {
                  var activeHours = c.active;
                  var activeMins = c.activeMins;
                  t = _objectSpread(_objectSpread({}, t), {}, {
                    activeHours: activeHours,
                    activeMins: activeMins
                  });
                }
                if (parameterCheck.some(function (t) {
                  return t.summary === "Productive";
                })) {
                  var productiveAppsTime = c.productive;
                  var productiveInMins = c.productiveInMins;
                  t = _objectSpread(_objectSpread({}, t), {}, {
                    productiveAppsTime: productiveAppsTime,
                    productiveInMins: productiveInMins
                  });
                }
                if (parameterCheck.some(function (t) {
                  return t.summary === "Unproductive";
                })) {
                  var unproductiveAppsTime = c.unproductive;
                  var unproductiveInMins = c.unproductiveInMins;
                  t = _objectSpread(_objectSpread({}, t), {}, {
                    unproductiveAppsTime: unproductiveAppsTime,
                    unproductiveInMins: unproductiveInMins
                  });
                }
                if (parameterCheck.some(function (t) {
                  return t.summary === "Neutral";
                })) {
                  var neutralAppsTime = c.neutral;
                  var neutralInMins = c.neutralInMins;
                  t = _objectSpread(_objectSpread({}, t), {}, {
                    neutralAppsTime: neutralAppsTime,
                    neutralInMins: neutralInMins
                  });
                }
                if (parameterCheck.some(function (t) {
                  return t.summary === "Untrack";
                })) {
                  var untrackedHours = c.untrack;
                  var untrackInMins = c.untrackInMins;
                  t = _objectSpread(_objectSpread({}, t), {}, {
                    untrackedHours: untrackedHours,
                    untrackInMins: untrackInMins
                  });
                }
                if (parameterCheck.some(function (t) {
                  return t.summary === "Manual";
                })) {
                  var manualHours = c.manual;
                  var manualInMins = c.manualInMins;
                  t = _objectSpread(_objectSpread({}, t), {}, {
                    manualHours: manualHours,
                    manualInMins: manualInMins
                  });
                }
                var timesheetMode = c.updatedBy ? "Manual" : "Automatic";
                t = _objectSpread(_objectSpread({}, t), {}, {
                  timesheetMode: timesheetMode
                });
                ws.addRow(t);
                return;
              });
              var ts = {
                date: "Total Work Summary",
                displayName: item.user.displayName.toString(),
                emailId: item.user.emailId,
                employeeId: item.user.employeeId,
                teamName: item.user.team
              };
              if (parameterCheck.some(function (t) {
                return t.summary === "clockIn";
              })) {
                var clockIn = "-";
                ts = _objectSpread(_objectSpread({}, ts), {}, {
                  clockIn: clockIn
                });
              }
              if (parameterCheck.some(function (t) {
                return t.summary === "clockOut";
              })) {
                var clockOut = "-";
                ts = _objectSpread(_objectSpread({}, ts), {}, {
                  clockOut: clockOut
                });
              }
              if (parameterCheck.some(function (t) {
                return t.summary === "Worked hours";
              })) {
                var totalWorkedHours = item.totalWorkedHours;
                var totalWorkInMins = item.totalWorkedMins;
                ts = _objectSpread(_objectSpread({}, ts), {}, {
                  totalWorkedHours: totalWorkedHours,
                  totalWorkInMins: totalWorkInMins
                });
              }
              if (parameterCheck.some(function (t) {
                return t.summary === "Break time";
              })) {
                var breakHours = item.totalBreakHours;
                var breakInMins = item.totalBreakMins;
                ts = _objectSpread(_objectSpread({}, ts), {}, {
                  breakHours: breakHours,
                  breakInMins: breakInMins
                });
              }
              if (parameterCheck.some(function (t) {
                return t.summary === "Idle time";
              })) {
                var idleHours = item.totalIdleHours;
                var idleInMins = item.totalIdleMins;
                ts = _objectSpread(_objectSpread({}, ts), {}, {
                  idleHours: idleHours,
                  idleInMins: idleInMins
                });
              }
              if (parameterCheck.some(function (t) {
                return t.summary === "Active time";
              })) {
                var activeHours = item.totalActiveHours;
                var activeMins = item.totalActiveMins;
                ts = _objectSpread(_objectSpread({}, ts), {}, {
                  activeHours: activeHours,
                  activeMins: activeMins
                });
              }
              if (parameterCheck.some(function (t) {
                return t.summary === "Productive";
              })) {
                var productiveAppsTime = item.totalProductiveHours;
                var productiveInMins = item.totalProductiveMins;
                ts = _objectSpread(_objectSpread({}, ts), {}, {
                  productiveAppsTime: productiveAppsTime,
                  productiveInMins: productiveInMins
                });
              }
              if (parameterCheck.some(function (t) {
                return t.summary === "Unproductive";
              })) {
                var unproductiveAppsTime = item.totalUnproductiveHours;
                var unproductiveInMins = item.totalUnproductiveMins;
                ts = _objectSpread(_objectSpread({}, ts), {}, {
                  unproductiveAppsTime: unproductiveAppsTime,
                  unproductiveInMins: unproductiveInMins
                });
              }
              if (parameterCheck.some(function (t) {
                return t.summary === "Neutral";
              })) {
                var neutralAppsTime = item.totalNeutralHours;
                var neutralInMins = item.totalNeutralMins;
                ts = _objectSpread(_objectSpread({}, ts), {}, {
                  neutralAppsTime: neutralAppsTime,
                  neutralInMins: neutralInMins
                });
              }
              if (parameterCheck.some(function (t) {
                return t.summary === "Untrack";
              })) {
                var untrackedHours = item.totalUntrackedHours;
                var untrackInMins = item.totalUntrackedMins;
                ts = _objectSpread(_objectSpread({}, ts), {}, {
                  untrackedHours: untrackedHours,
                  untrackInMins: untrackInMins
                });
              }
              if (parameterCheck.some(function (t) {
                return t.summary === "Manual";
              })) {
                var manualHours = item.totalManualHours;
                var manualInMins = item.totalManualMins;
                ts = _objectSpread(_objectSpread({}, ts), {}, {
                  manualHours: manualHours,
                  manualInMins: manualInMins
                });
              }
              var timesheetMode = "-";
              ts = _objectSpread(_objectSpread({}, ts), {}, {
                timesheetMode: timesheetMode
              });
              ws.addRow(ts);
              return;
            });
            ws.getRow(1).font = {
              bold: true
            };
            _context.next = 26;
            return wb.xlsx.writeBuffer();
          case 26:
            buf = _context.sent;
            fileName = "workfolio-timesheet-".concat(moment(Number(globalStartDate)).format("DD-MMM"), ".xlsx");
            if (globalEndDate != null) {
              fileName = "workfolio-timesheet-".concat(moment(Number(globalStartDate)).format("DD-MMM"), "-").concat(moment(Number(globalEndDate)).format("DD-MMM"), ".xlsx");
            }
            saveAs(new Blob([buf]), fileName);
            setExportButton(false);
          case 31:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function csvData(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  React.useEffect(function () {
    //exportButton
    if (exportData !== null && exportData !== void 0 && exportData.timesheetExport) {
      var _exportData$timesheet3;
      var dataValues = exportData === null || exportData === void 0 ? void 0 : (_exportData$timesheet3 = exportData.timesheetExport) === null || _exportData$timesheet3 === void 0 ? void 0 : _exportData$timesheet3.users;
      if (!dataValues) {
        return [];
      }
      if (exportLimit != 0) {
        setAllUsers(function (prevUsers) {
          return [].concat(_toConsumableArray(prevUsers), _toConsumableArray(dataValues));
        });
        if (loopInit <= loopCount) {
          exportOffsets = loopInit * exportLimit;
          setLoopInit(loopInit + 1);
          getExport({
            variables: {
              organisationId: organisationId,
              teamId: teamId,
              startDate: startDayUnix,
              endDate: endDayUnix,
              userRole: role,
              limit: exportLimit,
              offset: exportOffsets,
              search: search,
              // Continuation of the export started in getExportData below.
              isBatch: true
            }
          });
        }
        if (allUsers.length && loopInit == loopCount) {
          csvData(allUsers);
        }
      } else {
        csvData(dataValues);
      }
    }
  }, [exportData]);
  if (!timesheetValue) {
    return /*#__PURE__*/React.createElement("div", {
      className: "no-data"
    }, "No data found");
  }
  var displayNameWithSearch = function displayNameWithSearch(timesheetData) {
    if (!search) {
      return timesheetData;
    }
    return timesheetData.filter(function (filterTimesheetData) {
      var _filterTimesheetData$, _filterTimesheetData$2, _filterTimesheetData$3, _filterTimesheetData$4, _filterTimesheetData$5;
      return filterTimesheetData === null || filterTimesheetData === void 0 ? void 0 : (_filterTimesheetData$ = filterTimesheetData.user) === null || _filterTimesheetData$ === void 0 ? void 0 : (_filterTimesheetData$2 = _filterTimesheetData$.displayName) === null || _filterTimesheetData$2 === void 0 ? void 0 : (_filterTimesheetData$3 = _filterTimesheetData$2.toLowerCase) === null || _filterTimesheetData$3 === void 0 ? void 0 : (_filterTimesheetData$4 = _filterTimesheetData$3.call(_filterTimesheetData$2)) === null || _filterTimesheetData$4 === void 0 ? void 0 : (_filterTimesheetData$5 = _filterTimesheetData$4.includes) === null || _filterTimesheetData$5 === void 0 ? void 0 : _filterTimesheetData$5.call(_filterTimesheetData$4, search.toLowerCase());
    });
  };
  var displayNameForTimeWithSearch = function displayNameForTimeWithSearch(timesheetData) {
    if (!search) {
      return timesheetData;
    }
    return timesheetData.filter(function (filterTimesheetData) {
      var _filterTimesheetData$6, _filterTimesheetData$7, _filterTimesheetData$8, _filterTimesheetData$9;
      return filterTimesheetData === null || filterTimesheetData === void 0 ? void 0 : (_filterTimesheetData$6 = filterTimesheetData.displayName) === null || _filterTimesheetData$6 === void 0 ? void 0 : (_filterTimesheetData$7 = _filterTimesheetData$6.toLowerCase) === null || _filterTimesheetData$7 === void 0 ? void 0 : (_filterTimesheetData$8 = _filterTimesheetData$7.call(_filterTimesheetData$6)) === null || _filterTimesheetData$8 === void 0 ? void 0 : (_filterTimesheetData$9 = _filterTimesheetData$8.includes) === null || _filterTimesheetData$9 === void 0 ? void 0 : _filterTimesheetData$9.call(_filterTimesheetData$8, search.toLowerCase());
    });
  };
  var handlePrevious = function handlePrevious() {
    if (clickedIndex <= Number(daysDiff)) {
      clickedIndex = Number(clickedIndex) - 4;
      var t = -165 * clickedIndex + "px";
      setImageViewerPrevNavCount(t);
    }
  };
  var handleNext = function handleNext() {
    if (clickedIndex <= Number(daysDiff)) {
      clickedIndex = Number(clickedIndex) + 4;
      var t = -165 * clickedIndex + "px";
      setImageViewerPrevNavCount(t);
    }
  };
  var setParameterCheckValue = function setParameterCheckValue(e) {
    localStorage.setItem("timesheetParameter", JSON.stringify(e));
    setParameterCheck(e);
  };
  var options = [];
  if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped" && role != "Member") {
    options = [{
      label: "Clock In",
      value: "IN",
      summary: "clockIn"
    }, {
      label: "Clock Out",
      value: "OUT",
      summary: "clockOut"
    }, {
      label: "Worked Hours",
      value: "WORK",
      summary: "Worked hours",
      disabled: true
    }, {
      label: "Active Time",
      value: "ACTIVE",
      summary: "Active time",
      disabled: true
    }, {
      label: "Break Time",
      value: "BREAK",
      summary: "Break time",
      disabled: true
    }, {
      label: "Idle Time",
      value: "IDLE",
      summary: "Idle time",
      disabled: true
    }, {
      label: "Productive Apps Time (Prod)",
      value: "PRODUCTIVE",
      summary: "Productive",
      disabled: true
    }, {
      label: "Unproductive Apps Time (Unprod)",
      value: "UNPRODUCTIVE",
      summary: "Unproductive",
      disabled: true
    }, {
      label: "Neutral Apps Time (Neutrl)",
      value: "NEUTRAL",
      summary: "Neutral",
      disabled: true
    }, {
      label: "Untracked Time",
      value: "UNTRACK",
      summary: "Untrack",
      disabled: true
    }, {
      label: "Manual Time",
      value: "MANUAL",
      summary: "Manual",
      disabled: true
    }];
  } else {
    options = [{
      label: "Clock In",
      value: "IN",
      summary: "clockIn"
    }, {
      label: "Clock Out",
      value: "OUT",
      summary: "clockOut"
    }, {
      label: "Worked Hours",
      value: "WORK",
      summary: "Worked hours"
    }, {
      label: "Active Time",
      value: "ACTIVE",
      summary: "Active time"
    }, {
      label: "Break Time",
      value: "BREAK",
      summary: "Break time"
    }, {
      label: "Idle Time",
      value: "IDLE",
      summary: "Idle time"
    }, {
      label: "Productive Apps Time (Prod)",
      value: "PRODUCTIVE",
      summary: "Productive"
    }, {
      label: "Unproductive Apps Time (Unprod)",
      value: "UNPRODUCTIVE",
      summary: "Unproductive"
    }, {
      label: "Neutral Apps Time (Neutrl)",
      value: "NEUTRAL",
      summary: "Neutral"
    }, {
      label: "Untracked Time",
      value: "UNTRACK",
      summary: "Untrack"
    }, {
      label: "Manual Time",
      value: "MANUAL",
      summary: "Manual"
    }];
    if (!organisationSettings.manualTimeFeature) {
      options = [{
        label: "Clock In",
        value: "IN",
        summary: "clockIn"
      }, {
        label: "Clock Out",
        value: "OUT",
        summary: "clockOut"
      }, {
        label: "Worked Hours",
        value: "WORK",
        summary: "Worked hours"
      }, {
        label: "Active Time",
        value: "ACTIVE",
        summary: "Active time"
      }, {
        label: "Break Time",
        value: "BREAK",
        summary: "Break time"
      }, {
        label: "Idle Time",
        value: "IDLE",
        summary: "Idle time"
      }, {
        label: "Productive Apps Time (Prod)",
        value: "PRODUCTIVE",
        summary: "Productive"
      }, {
        label: "Unproductive Apps Time (Unprod)",
        value: "UNPRODUCTIVE",
        summary: "Unproductive"
      }, {
        label: "Neutral Apps Time (Neutrl)",
        value: "NEUTRAL",
        summary: "Neutral"
      }, {
        label: "Untracked Time",
        value: "UNTRACK",
        summary: "Untrack"
      }, {
        label: "Manual Time",
        value: "MANUAL",
        summary: "Manual",
        disabled: true
      }];
    }
  }
  var getExportData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setExportButton(true);
            setLoopInit(loopInit + 1);
            getExport({
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                startDate: startDayUnix,
                endDate: endDayUnix,
                userRole: role,
                limit: exportLimit,
                offset: exportOffsets,
                search: search,
                // The user-initiated request: this is the one that counts.
                isBatch: false
              }
            });
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getExportData() {
      return _ref2.apply(this, arguments);
    };
  }();
  var currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  var currentSystemDate = moment().tz(currentTimezone).format("MMMM DD");
  var orgTimezoneDate = moment().tz(organisationSettings.organisationTimezone).format("MMMM DD");
  return /*#__PURE__*/React.createElement(React.Fragment, null, !(props !== null && props !== void 0 && props.from) && window.innerWidth < 768 ? /*#__PURE__*/React.createElement(MobileView, null) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "timesheet-root"
  }, role != "Member" ? /*#__PURE__*/React.createElement(BillingDueExtendedMsg, {
    failedPlanEnd: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.failedPlanEnd,
    billingPeriodEnd: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.billingPeriodEnd,
    handleCheckout: null,
    pageName: "dashboard",
    planStatus: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus,
    history: props === null || props === void 0 ? void 0 : props.history
  }) : null, role != "Member" ? /*#__PURE__*/React.createElement(BillingBankTrasferPlanEndBeforeMsg, {
    beforePlanEndAlert: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.beforePlanEndAlert,
    planEnd: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planEnd,
    planStatus: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus,
    paymentType: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.paymentType
  }) : null, dateFilter == "Today" && currentSystemDate != orgTimezoneDate ? /*#__PURE__*/React.createElement(WarningCardOrgTimezone, {
    currentSystemDate: currentSystemDate,
    orgTimezoneDate: orgTimezoneDate,
    currentSystemTimezone: currentTimezone,
    organisationTimezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "timesheet-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "timesheet-checkbox-dropdown-label-link"
  }, "Note: Learn about timesheets effortlessly with", " ", /*#__PURE__*/React.createElement("a", {
    href: "https://workfolio.tawk.help/article/workfolio-timesheet-explained",
    target: "_blank"
  }, "this link"), "."), /*#__PURE__*/React.createElement("div", {
    className: "timesheet-checkbox-dropdown-label-checkbox"
  }, /*#__PURE__*/React.createElement("div", {
    className: "timesheet-checkbox-dropdown-label"
  }, "Filter Columns "), /*#__PURE__*/React.createElement("div", {
    className: "timesheet-checkbox-dropdown"
  }, /*#__PURE__*/React.createElement(MultiSelect, {
    options: options,
    value: parameterCheck,
    onChange: function onChange(e) {
      setParameterCheckValue(e);
    },
    labelledBy: "Select",
    defaultValue: {
      label: "Select Dept",
      value: 0
    },
    overrideStrings: {
      allItemsAreSelected: "All items selected "
    }
  }))), (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" ? /*#__PURE__*/React.createElement(React.Fragment, null, !exportButton ? /*#__PURE__*/React.createElement(Button, {
    className: "timesheet-export-button-header timesheet-export-button",
    variant: "primary",
    disabled: exportLoading,
    onClick: function onClick() {
      return getExportData();
    }
  }, exportLoading ? "Downloading" : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HiDownload, {
    className: "timesheet-download-icon"
  }), " Export")) : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "The download is currently in progress.")
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: " timesheet-export-button-header timesheet-export-button shift-detail-filter-download-icon-btn",
    disabled: true
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "daily-attendance-filter-download-icon"
  }), "Downloading"))) : role != "Member" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to export timesheet")
  }, /*#__PURE__*/React.createElement("div", {
    className: "timesheet-export-button-header disable-timesheet"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "timesheet-download-icon"
  }), " Export"))) : null), /*#__PURE__*/React.createElement("div", {
    className: "timesheet-header-row timesheet-row",
    style: {
      display: "grid",
      gridTemplateColumns: "200px minmax(0, 1fr) 200px"
    }
  }, /*#__PURE__*/React.createElement("div", null, "EMPLOYEE"), /*#__PURE__*/React.createElement("div", {
    className: "timesheet-data-header"
  }, Number(daysDiff) > 4 && clickedIndex > 0 ? /*#__PURE__*/React.createElement("span", {
    className: "timesheet-nav-left",
    onClick: function onClick() {
      return handlePrevious();
    }
  }, /*#__PURE__*/React.createElement(MdKeyboardArrowLeft, {
    className: "timesheet-nav-left-icon"
  })) : /*#__PURE__*/React.createElement("span", {
    className: "timesheet-nav-left-disable"
  }, /*#__PURE__*/React.createElement(MdKeyboardArrowLeft, {
    className: "timesheet-nav-left-icon"
  })), /*#__PURE__*/React.createElement("label", {
    className: "timesheet-data-header-name timesheet-data-header-details"
  }, dateFilter), " ", dateFilter === "Today" || dateFilter === "Yesterday" || dateFilter === "Last Month" || dateFilter === "Last Week" || dateFilter === "Last 7 Days" || dateFilter === "This Month" || dateFilter === "This Week" ? /*#__PURE__*/React.createElement("label", {
    className: "timesheet-data-header-date timesheet-data-header-details"
  }, isSameDay(globalStartDate, globalEndDate !== null && globalEndDate !== void 0 ? globalEndDate : globalStartDate) ? "(".concat(moment(globalStartDate).tz(currentTimezone).format("DD MMM,YYYY"), ")") : "(".concat(moment(globalStartDate).tz(currentTimezone).format("DD MMM,YYYY"), " - ").concat(moment(globalEndDate !== null && globalEndDate !== void 0 ? globalEndDate : globalStartDate).tz(currentTimezone).format("DD MMM,YYYY"), ")")) : null, Number(daysDiff) > 4 && clickedIndex <= Number(daysDiff) - 4 ? /*#__PURE__*/React.createElement("span", {
    className: "timesheet-nav-right",
    onClick: function onClick() {
      return handleNext();
    }
  }, /*#__PURE__*/React.createElement(MdKeyboardArrowRight, null)) : /*#__PURE__*/React.createElement("span", {
    className: "timesheet-nav-right-disable"
  }, /*#__PURE__*/React.createElement(MdKeyboardArrowRight, null))), /*#__PURE__*/React.createElement("div", {
    className: "timesheet-work-summary-header"
  }, "TOTAL WORK SUMMARY")), timesheetLoading ? /*#__PURE__*/React.createElement("div", {
    className: "timesheetLoader"
  }, /*#__PURE__*/React.createElement(Loader, null)) : timesheetError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : /*#__PURE__*/React.createElement(React.Fragment, null, timesheetValue.length == 0 && search.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "timesheetLoader timesheet-Loader-No-Result"
  }, "No search results found.") : /*#__PURE__*/React.createElement("div", {
    className: "timesheet-content-row timesheet-row",
    style: {
      display: "grid",
      gridTemplateColumns: "200px minmax(0, 1fr) 200px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "timesheet-content-row-member-grid"
    // style={{
    //   gridTemplateRows: `repeat(${timesheetValue?.length}, 6.7rem)`,
    // }}
    ,
    style: {
      gridTemplateRows: "repeat(".concat((_displayNameWithSearc = displayNameWithSearch(timesheetValue)) === null || _displayNameWithSearc === void 0 ? void 0 : _displayNameWithSearc.length, ", auto)")
    }
  }, (_displayNameWithSearc2 = displayNameWithSearch(timesheetValue)) === null || _displayNameWithSearc2 === void 0 ? void 0 : _displayNameWithSearc2.map(function (timesheet) {
    var _timesheet$user, _timesheet$user2, _timesheet$user3, _timesheet$user4, _timesheet$user5, _timesheet$user6, _timesheet$user7, _timesheet$user8;
    return /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-display-name-header"
    }, timesheet.user.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: (_timesheet$user = timesheet.user) === null || _timesheet$user === void 0 ? void 0 : _timesheet$user.profileUrl,
      className: "team-card-avatar-profile-img"
    })), /*#__PURE__*/React.createElement("div", {
      key: timesheet.user.userId,
      style: {
        height: "auto"
      },
      className: "timesheet-content-row-member-grid-displayname-profile-data"
    }, from === "desktop" ? /*#__PURE__*/React.createElement(React.Fragment, null, timesheet.user.displayName) : /*#__PURE__*/React.createElement(Link, _extends({}, _defineProperty({}, linkProps, "/personal-statistics/".concat((_timesheet$user2 = timesheet.user) === null || _timesheet$user2 === void 0 ? void 0 : _timesheet$user2.uniqueUrl)), {
      key: "timesheet-".concat((_timesheet$user3 = timesheet.user) === null || _timesheet$user3 === void 0 ? void 0 : _timesheet$user3.userId)
    }), timesheet.user.displayName), timesheet.user.employeeId ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "employee-id-".concat((_timesheet$user4 = timesheet.user) === null || _timesheet$user4 === void 0 ? void 0 : _timesheet$user4.userId),
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Emp ID: ", timesheet.user.employeeId)
    }, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-employee-id"
    }, "Emp Id: ", timesheet.user.employeeId)) : null)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-data-details-avatar-circle text-white"
    }, (_timesheet$user5 = timesheet.user) === null || _timesheet$user5 === void 0 ? void 0 : _timesheet$user5.displayName.charAt(0)), /*#__PURE__*/React.createElement("div", {
      key: timesheet.user.userId,
      style: {
        height: "auto"
      },
      className: "timesheet-content-row-member-grid-displayname-data"
    }, from === "desktop" || role == "Member" ? /*#__PURE__*/React.createElement(React.Fragment, null, timesheet.user.displayName) : /*#__PURE__*/React.createElement(Link, _extends({}, _defineProperty({}, linkProps, "/personal-statistics/".concat((_timesheet$user6 = timesheet.user) === null || _timesheet$user6 === void 0 ? void 0 : _timesheet$user6.uniqueUrl)), {
      key: "timesheet-".concat((_timesheet$user7 = timesheet.user) === null || _timesheet$user7 === void 0 ? void 0 : _timesheet$user7.userId)
    }), timesheet.user.displayName), timesheet.user.employeeId ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "employee-id-".concat((_timesheet$user8 = timesheet.user) === null || _timesheet$user8 === void 0 ? void 0 : _timesheet$user8.userId),
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Emp ID: ", timesheet.user.employeeId)
    }, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-employee-id"
    }, "Emp Id: ", timesheet.user.employeeId)) : null)));
  })), /*#__PURE__*/React.createElement("div", {
    className: "timesheet-content-row-border"
  }, /*#__PURE__*/React.createElement("div", {
    className: "timesheet-content-row-border-grid",
    style: {
      gridTemplateRows: "repeat(".concat((_displayNameWithSearc3 = displayNameWithSearch(timesheetValue)) === null || _displayNameWithSearc3 === void 0 ? void 0 : _displayNameWithSearc3.length, ", auto)"),
      gridTemplateColumns: "repeat(".concat(Math.max(0, daysDiff), ", 195px)"),
      marginLeft: "".concat(ImageViewerPrevNavCount)
    }
  }, _toConsumableArray(new Array(((_timesheetValue = timesheetValue) === null || _timesheetValue === void 0 ? void 0 : _timesheetValue.length) * Number(daysDiff))).map(function (_, memberIndex) {
    var _timesheet$displayNam, _timesheet$displayNam2, _timesheet$displayNam3, _timesheet$displayNam4;
    var timesheet = times[memberIndex] || {};
    if (!(timesheet !== null && timesheet !== void 0 && (_timesheet$displayNam = timesheet.displayName) !== null && _timesheet$displayNam !== void 0 && (_timesheet$displayNam2 = _timesheet$displayNam.toLowerCase) !== null && _timesheet$displayNam2 !== void 0 && (_timesheet$displayNam3 = _timesheet$displayNam2.call(_timesheet$displayNam)) !== null && _timesheet$displayNam3 !== void 0 && (_timesheet$displayNam4 = _timesheet$displayNam3.includes) !== null && _timesheet$displayNam4 !== void 0 && _timesheet$displayNam4.call(_timesheet$displayNam3, search.toLowerCase()))) {
      return null;
    }
    var timesheetDayType = arrayToStringOutputForTimesheet([timesheet.date, null], organisationSettings.organisationTimezone);
    return /*#__PURE__*/React.createElement("div", {
      key: memberIndex
    }, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-border-grid-day-card ".concat(timesheet.dayType === "absent" ? "timesheet-content-row-border-grid-day-card-absent" : timesheet.updatedBy && (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" ? "timesheet-content-row-border-grid-day-card-edited" : null)
    }, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-day"
    }, timesheetDayType == "Today" ? "Today" : timesheetDayType == "Yesterday" ? "Yesterday" : timesheet.day || weekdays[memberIndex % Number(daysDiff)], role == "Admin" && (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" && organisationBilling.planStatus != "stopped" ? /*#__PURE__*/React.createElement(React.Fragment, null, timesheet.updatedBy ? /*#__PURE__*/React.createElement("span", {
      className: "timesheet-content-row-day-edit-timesheet-label"
    }, "(edited)") : "", /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Edit Timesheet")
    }, /*#__PURE__*/React.createElement(HiPencil, {
      className: "timesheet-content-row-day-edit-timesheet",
      onClick: function onClick() {
        handleEditUserModalShow({
          clockInTime: timesheet["in"],
          clockOutTime: timesheet.out,
          totalTimeSpentInMin: timesheet.workMinsWithoutUntrack,
          idleMin: timesheet.idleInMins,
          productiveMin: timesheet.productiveInMins,
          unproductiveMin: timesheet.unproductiveInMins,
          neutralMin: timesheet.neutralInMins,
          breakMin: timesheet.breakInMins,
          untrackedMin: timesheet.untrackInMins,
          team: timesheet.team,
          user: {
            displayName: timesheet.displayName,
            uniqueUrl: timesheet.uniqueUrl,
            profileUrl: timesheet.profileUrl,
            userId: timesheet.userId
          },
          startDate: timesheet.dateForEditTimesheet,
          dateMS: timesheet.date
        });
      }
    }))) : role == "Admin" && (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" || role == "Admin" && (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) == "stopped" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Please upgrade your plan to edit timesheet")
    }, /*#__PURE__*/React.createElement("span", {
      className: ""
    }, /*#__PURE__*/React.createElement(HiPencil, {
      className: "timesheet-content-row-day-edit-timesheet timesheet-content-row-day-edit-timesheet-disabled"
    }))) : null), timesheet.date ? /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-date"
    }, timesheet.dateString) : null), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-content ".concat(timesheet.dayType === "absent" ? "timesheet-content-row-content-absent" : timesheet.updatedBy && (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" ? "timesheet-content-row-content-edited" : null)
    }, parameterCheck.map(function (category) {
      var clockInTemp = "00:00";
      var clockOutTemp = "00:00";
      if (category.value === "IN") {
        clockInTemp = timesheet[category.value.toLowerCase()] !== undefined && timesheet[category.value.toLowerCase()] !== null ? moment(Number(timesheet[category.value.toLowerCase()])).format("hh:mm a") : Number(timesheet.workInMins) > 0 ? "-" : "00:00";
      }
      if (category.value === "OUT") {
        clockOutTemp = timesheet[category.value.toLowerCase()] === "Working On" || timesheet[category.value.toLowerCase()] === "-" ? timesheet[category.value.toLowerCase()] : timesheet[category.value.toLowerCase()] !== undefined && timesheet[category.value.toLowerCase()] !== null ? moment(Number(timesheet[category.value.toLowerCase()])).format("hh:mm a") : "00:00";
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "timesheet-content-row-content-line"
      }, /*#__PURE__*/React.createElement("div", {
        className: "timesheet-content-row-content-line-time"
      }, category.value === "IN" ? clockInTemp : category.value === "OUT" ? clockOutTemp : category.value === "WORK" && timesheet["workInMins"] >= 1080 && timesheet.updatedBy == null ? /*#__PURE__*/React.createElement(React.Fragment, null, "Error in hour, Contact support") : category.value === "ACTIVE" && timesheet["activeMins"] >= 1080 && timesheet.updatedBy == null ? /*#__PURE__*/React.createElement(React.Fragment, null, "Error in hour") : category.value === "PRODUCTIVE" && timesheet["productiveInMins"] >= 1080 && timesheet.updatedBy == null ? /*#__PURE__*/React.createElement(React.Fragment, null, "Error in hour") : category.value === "UNPRODUCTIVE" && timesheet["unproductiveInMins"] >= 1080 && timesheet.updatedBy == null ? /*#__PURE__*/React.createElement(React.Fragment, null, "Error in hour") : category.value === "NEUTRAL" && timesheet["neutralInMins"] >= 1080 && timesheet.updatedBy == null ? /*#__PURE__*/React.createElement(React.Fragment, null, "Error in hour") : timesheet[category.value.toLowerCase()] || "00:00"), /*#__PURE__*/React.createElement("div", {
        className: "timesheet-content-row-content-line-category"
      }, category.value === "PRODUCTIVE" && timesheet["productiveInMins"] >= 1080 && timesheet.updatedBy == null ? "-" : category.value === "UNPRODUCTIVE" && timesheet["unproductiveInMins"] >= 1080 && timesheet.updatedBy == null ? "-" : category.value === "NEUTRAL" && timesheet["neutralInMins"] >= 1080 && timesheet.updatedBy == null ? "-" : category.value === "PRODUCTIVE" ? "PROD" : category.value === "UNPRODUCTIVE" ? "UNPROD" : category.value === "NEUTRAL" ? "NEUTRL" : category.value === "WORK" && timesheet["workInMins"] >= 1080 && timesheet.updatedBy == null ? "-" : category.value === "ACTIVE" && timesheet["activeMins"] >= 1080 && timesheet.updatedBy == null ? "-" : category.value));
    }))));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "timesheet-content-row-member-grid",
    style: {
      gridTemplateRows: "repeat(".concat((_displayNameWithSearc4 = displayNameWithSearch(timesheetValue)) === null || _displayNameWithSearc4 === void 0 ? void 0 : _displayNameWithSearc4.length, ", auto)")
    }
  }, (_displayNameWithSearc5 = displayNameWithSearch(timesheetValue)) === null || _displayNameWithSearc5 === void 0 ? void 0 : _displayNameWithSearc5.map(function (member, memberIndex) {
    var _timesheetValue2;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        gridTemplateRows: "repeat(".concat((_timesheetValue2 = timesheetValue) === null || _timesheetValue2 === void 0 ? void 0 : _timesheetValue2.length, ", ").concat(parameterCheck.length < 3 ? "6.7" : 6.7 + (parameterCheck.length - 2), "rem)")
      },
      className: "timesheet-content-row-member-grid-displayname-profile-data "
    }, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-displayname-date"
    }, parameterCheck.some(function (t) {
      return t.summary === "Worked hours";
    }) ? /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours"
    }, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours-value"
    }, member.totalWorkedMins), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours-label"
    }, "Worked hours", " ")) : null, parameterCheck.some(function (t) {
      return t.summary === "Break time";
    }) ? /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours"
    }, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours-value"
    }, member.totalBreakMins), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours-label"
    }, "Break time", " ")) : null, parameterCheck.some(function (t) {
      return t.summary === "Idle time";
    }) ? /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours"
    }, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours-value"
    }, member.totalIdleMins), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours-label"
    }, "Idle time ")) : null, parameterCheck.some(function (t) {
      return t.summary === "Active time";
    }) ? /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours"
    }, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours-value"
    }, member.totalActiveMins), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours-label"
    }, "Active time", " ")) : null, parameterCheck.some(function (t) {
      return t.summary === "Productive";
    }) ? /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours"
    }, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours-value"
    }, member.totalProductiveMins), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours-label"
    }, "Productive Apps Time")) : null, parameterCheck.some(function (t) {
      return t.summary === "Unproductive";
    }) ? /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours"
    }, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours-value"
    }, member.totalUnproductiveMins), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours-label"
    }, "Unproductive Apps Time")) : null, parameterCheck.some(function (t) {
      return t.summary === "Neutral";
    }) ? /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours"
    }, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours-value"
    }, member.totalNeutralMins), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours-label"
    }, "Neutral Apps Time")) : null, parameterCheck.some(function (t) {
      return t.summary === "Untrack";
    }) ? /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours"
    }, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours-value"
    }, member.totalUntrackedMins), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours-label"
    }, "Untrack Time")) : null, parameterCheck.some(function (t) {
      return t.summary === "Manual";
    }) ? /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours"
    }, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours-value"
    }, member.totalManualMins), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours-label"
    }, "Manual Time")) : null, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours "
    }, /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours-value timesheet-day"
    }, member.totalWorkedDays), /*#__PURE__*/React.createElement("div", {
      className: "timesheet-content-row-member-grid-worked-hours-label timesheet-day-label"
    }, "Worked days", " "))));
  }))))), search.length == 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, organisationUserCount && Math.ceil(Number(organisationUserCount) / USER_LIMIT) > 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "timeline-pagination-section-label-timesheet"
  }, "Navigate to next section to see other members timesheet"), /*#__PURE__*/React.createElement("div", {
    className: "timeline-pagination-section-timesheet"
  }, /*#__PURE__*/React.createElement(Pagination, null, function () {
    var items = [];
    var _loop = function _loop(number) {
      items.push( /*#__PURE__*/React.createElement(Pagination.Item, {
        key: number,
        active: number === activeTimeline,
        onClick: function onClick() {
          setActiveTimeline(number);
        }
      }, number));
    };
    for (var number = 1; number <= Math.ceil(Number(organisationUserCount) / USER_LIMIT); number++) {
      _loop(number);
    }
    return items;
  }()))) : null) : userTimeSheetCountLoading ? /*#__PURE__*/React.createElement(Loader, null) : userTimeSheetCountData !== null && userTimeSheetCountData !== void 0 && userTimeSheetCountData.userTimeSheetCount && Math.ceil(Number(userTimeSheetCountData === null || userTimeSheetCountData === void 0 ? void 0 : userTimeSheetCountData.userTimeSheetCount) / USER_LIMIT) > 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "timeline-pagination-section-label"
  }, "Navigate to next section to see other members timeline"), /*#__PURE__*/React.createElement("div", {
    className: "timeline-pagination-section"
  }, /*#__PURE__*/React.createElement(Pagination, null, function () {
    var items = [];
    var _loop2 = function _loop2(number) {
      items.push( /*#__PURE__*/React.createElement(Pagination.Item, {
        key: number,
        active: number === activeTimeline,
        onClick: function onClick() {
          setActiveTimeline(number);
        }
      }, number));
    };
    for (var number = 1; number <= Math.ceil(Number(userTimeSheetCountData === null || userTimeSheetCountData === void 0 ? void 0 : userTimeSheetCountData.userTimeSheetCount) / USER_LIMIT); number++) {
      _loop2(number);
    }
    return items;
  }()))) : null), /*#__PURE__*/React.createElement(EditUserDetailsModal, {
    editUserModalShow: editUserModalShow,
    handleEditUserModalClose: handleEditUserModalClose,
    teamData: teamData === null || teamData === void 0 ? void 0 : teamData.organisationTeams,
    organisationId: organisationId,
    startDate: null,
    timeZone: organisationSettings.organisationTimezone,
    userSearch: null,
    Link: Link,
    linkProps: linkProps,
    teamId: teamId,
    startDayUnix: startDayUnix,
    endDayUnix: endDayUnix,
    role: role,
    USER_LIMIT: USER_LIMIT,
    activeTimeline: activeTimeline,
    search: search,
    pageType: "timesheet",
    user: user,
    dateFilter: dateFilter,
    timezoneFilter: timezoneFilter,
    setEditUserModalShow: setEditUserModalShow
  }));
};
var MobileView = function MobileView(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "WarningScreen-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "WarningScreen-root-img"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Workfolio",
    src: Profile,
    className: " m-b-20",
    width: "40",
    height: "40"
  })), /*#__PURE__*/React.createElement("p", {
    className: "WarningScreen-text-sry"
  }, "Sorry for the inconvenience."), /*#__PURE__*/React.createElement("p", {
    className: "WarningScreen-text"
  }, "Please visit timesheet page from computer."));
};
export default TimeSheet;